<template>
  <div class="content-wrapper">
    <vx-card>
      <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
        <vs-tab label="Basic Info" icon-pack="feather" icon="icon-user">
          <div class="tab-text">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="user.name" />
              </div>
            </div>
            <div style="height:10px;"></div>
            <div class="vx-row pt-5 mt-5">
              <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button class="mr-3 mb-2" @click="submitBasic"
                  >Submit</vs-button
                >
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Password" icon-pack="feather" icon="icon-lock">
          <div class="tab-text">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Current Password</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  class="w-full"
                  type="password"
                  v-model="password.current_password"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>New Password</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  class="w-full"
                  type="password"
                  v-model="password.password"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Confirm Password</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  class="w-full"
                  type="password"
                  v-model="password.confirm_password"
                />
              </div>
            </div>

            <div style="height:10px;"></div>
            <div class="vx-row pt-5 mt-5">
              <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button class="mr-3 mb-2" @click="submitPassword"
                  >Submit</vs-button
                >
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";

export default {
  components: {},
  data: () => ({
    activeTab: 0,
    user: {
      name: ""
    },
    password: {
      email: "",
      current_password: "",
      password: "",
      confirm_password: ""
    }
  }),
  created() {
    Service.Auth.getUser().then(res => {
      this.user.name = res.data.info.name;
      this.password.email = res.data.info.email;
    });
  },
  methods: {
    submitBasic() {
      this.$vs.loading();
      Service.Auth.updateProfile({ name: this.user.name }).then(res => {
        Service.Auth.getUser().then(res => {
          this.$store.commit("Auth/SET_USER", res.data);
          this.$store.dispatch("updateUserInfo", {
            displayName: this.user.name
          });
        });
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
        this.$vs.loading.close();
      });
    },
    submitPassword() {
      this.$vs.loading();
      Service.Auth.updateProfile(this.password).then(res => {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
        this.$vs.loading.close();
      });
    }
  }
};
</script>
